import type { ReactNode } from 'react';

interface EmptyStateProps {
  icon: ReactNode;
  title: string;
  description: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={`flex items-center justify-center h-64 ${className}`}
    >
      <div className="text-center">
        <div aria-hidden="true" className="mx-auto mb-4 flex items-center justify-center">{icon}</div>
        <h3 className="text-lg font-medium text-surface-900 mb-2">{title}</h3>
        <p className="text-surface-600">{description}</p>
        {action && <div className="mt-4">{action}</div>}
      </div>
    </div>
  );
}

export default EmptyState;
